import { useState, useRef } from 'react';
import { Instagram, Youtube, ExternalLink } from 'lucide-react';
import { SOCIAL } from '@/config/assets';
import AnalyticsDashboard from '@/components/AnalyticsDashboard';

export default function Footer() {
  const [showDash, setShowDash] = useState(false);
  const clickCount = useRef(0);
  const clickTimer = useRef(null);

  const handleLogoClick = () => {
    clickCount.current++;
    if (clickCount.current >= 3) {
      clickCount.current = 0;
      setShowDash(true);
    }
    clearTimeout(clickTimer.current);
    clickTimer.current = setTimeout(() => { clickCount.current = 0; }, 600);
  };

  return (
    <>
      <footer data-testid="footer" className="relative py-12 md:py-20 px-5 md:px-10 lg:px-20" style={{ background: 'var(--deep-black)', borderTop: '1px solid rgba(201,168,76,0.06)' }}>
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <button data-testid="footer-at-logo" onClick={handleLogoClick} className="font-['Playfair_Display'] italic font-normal text-2xl cursor-pointer at-shimmer" style={{ paddingLeft: '0.15em', paddingRight: '0.05em', display: 'inline-block' }}>
              AT.
            </button>
            <p className="font-['Inter'] text-[10px] mt-2 tracking-[0.1em]" style={{ color: 'var(--ash)', opacity: 0.4 }}>Avinash Tiwary</p>
          </div>

          <div className="flex items-center gap-6">
            {[
              { testId: 'social-instagram', icon: Instagram, url: SOCIAL.instagram },
              { testId: 'social-youtube', icon: Youtube, url: SOCIAL.youtube },
              { testId: 'social-imdb', icon: ExternalLink, url: SOCIAL.imdb },
            ].map(s => (
              <a key={s.testId} data-testid={s.testId} href={s.url} target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-[var(--gold)]" style={{ color: 'var(--ash)' }}>
                <s.icon className="w-4 h-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 mt-10">
          <p className="font-['Inter'] text-[10px] tracking-[0.1em]" style={{ color: 'rgba(136,136,136,0.3)' }}>&copy; {new Date().getFullYear()} Avinash Tiwary</p>
          <p className="font-['Inter'] text-[9px] tracking-[0.15em]" style={{ color: 'rgba(201,168,76,0.08)' }}>Invincible India</p>
        </div>
      </footer>

      {showDash && <AnalyticsDashboard onClose={() => setShowDash(false)} />}
    </>
  );
}
